<template>
  <div class="container" id="home">
    <div class="container ct-example-row">
      <div v-if="!isLoggedIn" class="row">
        <div class="col text-center mt-3">
          Please Sign In
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-6">
          <div class="card card-profile shadow mb-3">
           <div class="card-body">
              <div class="col-lg-8 offset-lg-2">
              <div class="card-profile-image text-center">
                <h2><router-link class="nav-link nav-link-icon" :class="{ disabled: isWorkdayButtonDisabled || !isLoggedIn }" :to="{name: 'workday'}"><i class="ni ni-watch-time"></i></router-link></h2>
              </div>
            </div>
            <div class="text-center mt-1">
              <h3><router-link class="nav-link nav-link-icon" :class="{ disabled: isWorkdayButtonDisabled || !isLoggedIn }" :to="{name: 'workday'}">{{ this.$store.state.workday.isStarted>0 ? 'End' : 'Start' }} Workday</router-link></h3>
            </div>
           </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card card-profile shadow mb-3">
           <div class="card-body">
              <div class="col-lg-8 offset-lg-2">
              <div class="card-profile-image text-center">
                <h2><router-link class="nav-link nav-link-icon" :class="{ disabled: isShiftButtonDisabled || !isLoggedIn }" :to="{name: 'shift'}"><i class="ni ni-watch-time"></i></router-link></h2>
              </div>
            </div>
            <div class="text-center mt-1">
              <h3><router-link class="nav-link nav-link-icon" :class="{ disabled: isShiftButtonDisabled || !isLoggedIn }" :to="{name: 'shift'}">{{ this.$store.state.shift.isStarted>0 ? 'End' : 'Start' }} Shift</router-link></h3>
            </div>
           </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card card-profile shadow mb-3">
           <div class="card-body">
              <div class="col-lg-8 offset-lg-2">
              <div class="card-profile-image text-center">
                <h2><router-link class="nav-link nav-link-icon" :to="{name: 'jobs'}" :class="{ disabled: !isLoggedIn }"><i class="fa fa-book" aria-hidden="true"></i></router-link></h2>
              </div>
            </div>
            <div class="text-center mt-1">
              <h3><router-link class="nav-link nav-link-icon" :to="{name: 'jobs'}" :class="{ disabled: !isLoggedIn }">Jobs</router-link></h3>
            </div>
           </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card card-profile shadow mb-3">
           <div class="card-body">
              <div class="col-lg-8 offset-lg-2">
              <div class="card-profile-image text-center">
                <h2><router-link class="nav-link nav-link-icon" :to="{name: 'forms'}" :class="{ disabled: !isLoggedIn }"><i class="fa fa-book" aria-hidden="true"></i></router-link></h2>
              </div>
            </div>
            <div class="text-center mt-1">
              <h3><router-link class="nav-link nav-link-icon" :to="{name: 'forms'}" :class="{ disabled: !isLoggedIn }">Forms</router-link></h3>
            </div>
           </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card card-profile shadow mb-3">
           <div class="card-body">
              <div class="col-lg-8 offset-lg-2">
              <div class="card-profile-image text-center">
                <h2><router-link class="nav-link nav-link-icon" :to="{name: 'accident'}" :class="{ disabled: !isLoggedIn }"><i class="fa fa-book" aria-hidden="true"></i></router-link></h2>
              </div>
            </div>
            <div class="text-center mt-1">
              <h3><router-link class="nav-link nav-link-icon" :to="{name: 'accident'}" :class="{ disabled: !isLoggedIn }">Accident</router-link></h3>
            </div>
           </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card card-profile shadow mb-3">
           <div class="card-body">
              <div class="col-lg-8 offset-lg-2">
              <div class="card-profile-image text-center">
                <h2><router-link class="nav-link nav-link-icon" :to="{name: 'weeklyreport'}" :class="{ disabled: !isLoggedIn }"><i class="fa fa-book" aria-hidden="true"></i></router-link></h2>
              </div>
            </div>
            <div class="text-center mt-1">
              <h3><router-link class="nav-link nav-link-icon" :to="{name: 'weeklyreport'}" :class="{ disabled: !isLoggedIn }">Weekly Report</router-link></h3>
            </div>
           </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed:
  {
    isShiftButtonDisabled: function () {
      return false // !this.$store.state.workday.isStarted
    },
    isWorkdayButtonDisabled: function () {
      return false // this.$store.state.shift.isStarted
    },
    isLoggedIn: function () {
      return this.$store.state.user.isLogin
    }
  }
}
</script>
<style scoped>
.disabled {
    opacity: 0.5;
    pointer-events: none;
}
</style>
